<div [ngClass]="{'lds-grid': true, 'danger': !online}"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
